import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { strings } from "../../utils/constants";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { paths } from "../../utils/constants";

export default function POPUP({ isOpen, closeHandler }) {

  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      keepMounted
    >
      <DialogContent>
        <button type="button" style={{ marginLeft: "95%" }} className="btn-close" aria-label="Close" onClick={closeHandler} ></button>
        <div className="modal-body px-5">
          {t(strings.translate.LIBRARY_POPUP_DESC)}
          <Link className="ms-1" to={paths.userRoutes.SUBSCRIPRION}>{t(strings.translate.LIBRARY_POPUP_LINK)}</Link>
        </div>
      </DialogContent>
    </Dialog>
  )
}